import { Button } from 'reakit/Button';

import GoogleBtnLogo from './GoogleBtnLogo.svg';
import styles from './styles';

const GoogleSignInButton = ({ classes, className, onClick }) => {
  return (
    <Button className={className} onClick={() => onClick()}>
      <div className={'flex items-center justify-center'}>
        <GoogleBtnLogo />
        <div
          className={classnames([
            'flex relative items-center justify-center text-white text-sm h-10',
            'pr-2 pl-3',
            classes.google_btn_text,
          ])}
        >
          <span>Sign in with Google</span>
        </div>
      </div>
    </Button>
  );
};

GoogleSignInButton.propTypes = {
  className: PropTypes.string,
};

GoogleSignInButton.defaultProps = {
  onClick: PropTypes.func,
};

export default withStyles(styles)(GoogleSignInButton);
